import { render } from "./MemberCardSetting.vue?vue&type=template&id=78cc3d45&scoped=true"
import script from "./MemberCardSetting.vue?vue&type=script&lang=js"
export * from "./MemberCardSetting.vue?vue&type=script&lang=js"

import "./MemberCardSetting.vue?vue&type=style&index=0&id=78cc3d45&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78cc3d45"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/MemberCardSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78cc3d45"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78cc3d45', __exports__)) {
    api.reload('78cc3d45', __exports__)
  }
  
  module.hot.accept("./MemberCardSetting.vue?vue&type=template&id=78cc3d45&scoped=true", () => {
    api.rerender('78cc3d45', render)
  })

}


export default __exports__